import { Component } from '@angular/core';

@Component({
  selector: 'cwo-dots-loader',
  standalone: true,
  imports: [],
  templateUrl: './dots-loader.component.html',
  styleUrl: './dots-loader.component.scss'
})
export class DotsLoaderComponent {

}
